import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path
                    d='M16.0776 18.8061L16.6341 19.7838L16.0776 18.8061C15.1981 19.3068 14.4181 20.1903 14.2485 21.3561L14.0276 22.875H9.96623L9.7459 21.3601C9.57602 20.192 8.79387 19.3058 7.91458 18.8029C7.04349 18.3046 5.92476 18.1013 4.85961 18.5196L3.29515 19.134L1.29361 15.7601L2.58238 14.7766C3.50612 14.0716 3.87181 12.983 3.87181 12C3.87181 11.017 3.50612 9.9284 2.58238 9.22345L1.29361 8.23992L3.29515 4.86602L4.85549 5.47877C5.9258 5.89908 7.04753 5.68846 7.91627 5.1939C8.79577 4.69323 9.57577 3.80969 9.74532 2.64394L9.96623 1.125H14.0338L14.2541 2.63989C14.424 3.80796 15.2061 4.69421 16.0854 5.19715C16.9565 5.69539 18.0752 5.89867 19.1404 5.48038L20.7049 4.86601L22.7061 8.23944L21.4133 9.22374C20.4885 9.92784 20.122 11.0167 20.122 12C20.122 12.983 20.4877 14.0716 21.4115 14.7766L22.7002 15.7601L20.6987 19.134L19.1383 18.5212C18.068 18.1009 16.9463 18.3115 16.0776 18.8061ZM6.5552 12C6.5552 14.9722 9.01834 17.325 11.9969 17.325C14.9755 17.325 17.4386 14.9722 17.4386 12C17.4386 9.02781 14.9755 6.675 11.9969 6.675C9.01834 6.675 6.5552 9.02781 6.5552 12Z'
                    fill='transparent'
                    stroke='currentColor'
                    strokeWidth='2.25'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
